import axios from 'axios';
import { API_URL } from '../utils/apiConfig';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export const getSurveyStats = async () => {
  const res = await axios.get(`${API_URL}/surveys/stats`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const getSurveys = async (params = {}) => {
  const res = await axios.get(`${API_URL}/surveys`, {
    headers: authHeaders(),
    params,
  });
  return res.data;
};

export const respondSurvey = async (id, payload) => {
  const res = await axios.put(`${API_URL}/surveys/${id}/respond`, payload, {
    headers: authHeaders(),
  });
  return res.data;
};
